import React from 'react';

const TIERS = [
  { value: 0, label: 'Off', description: 'Nothing leaves this device.' },
  { value: 1, label: 'Anonymous metrics', description: 'Usage stats & AI performance. No message content.' },
  { value: 2, label: 'Include AI content', description: 'Also share AI prompts & outputs to help improve quality. Phone numbers & names always removed.' },
];

interface Props {
  sharingTier: number;
  onChange: (tier: number) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function DataSharingStep({ sharingTier, onChange, onNext, onBack }: Props) {
  return (
    <div>
      <p className="text-xs font-medium text-ink-tertiary uppercase tracking-wider mb-1" data-ph-no-mask>
        Step 5 of 6
      </p>
      <h1 className="text-2xl font-bold text-ink mb-1" data-ph-no-mask>Help improve Clawer</h1>
      <p className="text-sm text-ink-secondary mb-6 leading-relaxed" data-ph-no-mask>
        Share anonymous usage data so we can make Clawer better.
        You can change this anytime in Settings.
      </p>

      <div className="flex flex-col gap-2 mb-6">
        {TIERS.map((t) => (
          <label
            key={t.value}
            className={`flex items-start gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${
              sharingTier === t.value ? 'border-accent bg-accent/5' : 'border-edge'
            }`}
          >
            <input
              type="radio"
              name="sharing-tier-setup"
              value={t.value}
              checked={sharingTier === t.value}
              onChange={() => onChange(t.value)}
              className="mt-0.5"
            />
            <div>
              <span className="text-sm font-medium text-ink" data-ph-no-mask>{t.label}</span>
              <p className="text-xs text-ink-secondary mt-0.5" data-ph-no-mask>{t.description}</p>
            </div>
          </label>
        ))}
      </div>

      <div className="flex gap-3">
        <button
          onClick={onBack}
          className="px-4 py-2.5 rounded-lg border border-edge text-sm font-medium text-ink hover:bg-canvas transition-colors"
          data-ph-no-mask
        >
          Back
        </button>
        <button
          onClick={onNext}
          className="px-5 py-2.5 rounded-lg bg-accent text-white text-sm font-medium hover:bg-accent-deep transition-colors"
          data-ph-no-mask
        >
          Next
        </button>
      </div>
    </div>
  );
}
